import React from "react";

const NoComponentPage = ({ name, domain, subdomain }) => {
  console.log("NoComponentPage called", name);
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center 
                    bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 
                    animate-gradient text-white p-8"
    >
      <h1 className="font-heading text-6xl font-bold mb-4">{name}</h1>
      {subdomain === "undefined" || !subdomain ? (
        <p className="text-2xl mb-2">{domain}</p>
      ) : (
        <p className="text-2xl mb-2">
          {domain}/{subdomain}
        </p>
      )}
      <p className="text-lg italic">
        This page is being built... come back soon!
      </p>
    </div>
  );
};

export default NoComponentPage;
